export const formatDateIT = (input) => {
  if (!input) return "—";
  // Accept ISO yyyy-mm-dd or full datetime string
  const iso = typeof input === "string" ? input : String(input);
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (match) {
    const [, y, m, d] = match;
    return `${d}/${m}/${y}`;
  }
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("it-IT");
};

export const formatDateTimeIT = (input) => {
  if (!input) return "—";
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("it-IT", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export const relativeTime = (iso, lang = "it") => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const sec = Math.round(diffMs / 1000);
  const min = Math.round(sec / 60);
  const hour = Math.round(min / 60);
  const day = Math.round(hour / 24);
  const dict = {
    it: { now: "adesso", min_1: "1 minuto fa", min_n: "$ minuti fa", hour_1: "1 ora fa", hour_n: "$ ore fa", day_1: "ieri", day_n: "$ giorni fa" },
    en: { now: "just now", min_1: "1 minute ago", min_n: "$ minutes ago", hour_1: "1 hour ago", hour_n: "$ hours ago", day_1: "yesterday", day_n: "$ days ago" },
  };
  const l = dict[lang] || dict.it;
  if (sec < 60) return l.now;
  if (min < 60) return min === 1 ? l.min_1 : l.min_n.replace("$", min);
  if (hour < 24) return hour === 1 ? l.hour_1 : l.hour_n.replace("$", hour);
  if (day < 30) return day === 1 ? l.day_1 : l.day_n.replace("$", day);
  return d.toLocaleDateString("it-IT");
};

export const STORE_IMAGES = {
  jannelli: "https://images.unsplash.com/photo-1601599963565-b7f49deb42a2?auto=format&fit=crop&w=800&q=60",
  parafarmacia: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&w=800&q=60",
  materdomini: "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=800&q=60",
  mazzini: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=800&q=60",
};

export const CATEGORY_FALLBACK_IMAGE = "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=600&q=60";

// Italian names ending in "a" that are masculine (exceptions to the ends-in-a → feminine rule)
const MASCULINE_A_ENDING = new Set([
  "andrea", "luca", "nicola", "mattia", "elia", "enea", "battista",
  "barnaba", "bonaventura", "isaia", "geremia", "giona", "zaccaria",
  "osea", "amilcare", "attila", "boccadoro", "gioacchino", "ezechia",
  "malachia", "abaco", "seneca", "leuca", "tobia", "mosè", "noè",
]);

// Feminine names that don't end in "a"
const FEMININE_NON_A = new Set([
  "beatrice", "alice", "agnese", "adele", "irene", "gioia", "rachele",
  "ester", "ruth", "miriam", "rebecca", "carmen", "ines", "consuelo",
  "eleonor", "eleonore", "esther", "iris", "noemi", "ruth", "sarah",
  "dolores", "mercedes", "maribel", "isabel", "abigail", "sole",
  "yasmine", "jasmine", "amber", "amber", "clover", "hope", "faith",
  "ann", "anne", "elisabeth", "elizabeth", "michelle", "nicole",
  "jacqueline", "marlene", "helen", "ellen", "kathleen", "lauren",
  "megan", "meghan", "morgan", "kim", "jean", "joan", "june",
]);

export const isFeminineName = (rawName) => {
  if (!rawName) return false;
  const first = rawName.trim().split(/\s+/)[0].toLowerCase();
  if (!first) return false;
  if (FEMININE_NON_A.has(first)) return true;
  if (MASCULINE_A_ENDING.has(first)) return false;
  // Default Italian heuristic: ends in 'a' → feminine
  return first.endsWith("a");
};
